import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import DemandTable from "./DemandTable";
import btnDownloadIcon from "./../../Assests/download.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
} from "../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  CGO_DEMAND_DOWNLOAD_API,
  CGO_DEMAND_GET_API,
  CGO_DEMAND_UPDATE_API,
  VIEW_MANUFACTURING_MASTER_2_TABLE_API,
} from "../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import * as actions from "../../Redux/Actions/index";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import btnSaveIcon from "./../../Assests/Save-btn.svg";

import AddRowButton from "../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../Components/Common/ConfirmationDialog";

function Demand(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectLocationCode, setSelectLocationCode] = useState<any>("");
  const [selectCascade, setSelectCascade] = useState<any>("");
  const [selectLocationDesc, setSelectLocationDesc] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [locationCodeOptions, setLocationCodeOptions] = React.useState([]);
  const [cascadeOptions, setCascadeOptions] = useState<any>([]);
  const [locationDescOptions, setLocationDescOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);
  const [filterRequest, setFilterRequest] = React.useState([
    { key: "demand_location_Code", value: "" },
    { key: "demand_Location_Description", value: "" },
  ]);

  const sortedFactoryNames = locationCodeOptions?.sort((a: any, b: any) =>
    a?.demand_location_Code.localeCompare(b?.demand_location_Code)
  );

  /**Redux state */
  const selectedUsecaseeId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage
  );

  useEffect(() => {
    callTableGridApi();
    getfiltersApi();
  }, [selectedFolderId, selectedScenarioId]);

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    console.log(newSelection, selectedRows, "newSelection");
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  var LC = 0;
  var LD = 0;
  const handleChangeSelectLocationCode = (event: any) => {
    setSelectLocationDesc("");
    filterRequest[1].value = "";
    const {
      target: { value },
    } = event;
    setSelectLocationCode(value);
    filterRequest[0].value = value;
    callTableGridApi();
    LC = 1;
    LD = 0;
  };

  const handleChangeSelectLocationDesc = (event: any) => {
    LC = 1;
    LD = 1;
    const {
      target: { value },
    } = event;
    setSelectLocationDesc(value);
    filterRequest[1].value = value;
    callTableGridApi();
  };

  const callTableGridApi = (resetfilter?: any) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");

    //const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": selectedScenarioId > 0 ? "tblShiftChangeover_HC_Rerun" : "tblShiftChangeover", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList };

    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: "tblcog_Demand",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: resetfilter ? resetfilter : filterList,
      time_period: "",
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + CGO_DEMAND_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        let filterIndex = response.data.length - 1;
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          setRows(response.data);
          if (LC === 0)
            setLocationCodeOptions(loadLocationCodeOptions(response.data));
          if (LD === 0)
            setLocationDescOptions(loadLocationDescOptions(response.data));
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(ViewProductTableError(error));
      });
  };

  const loadLocationCodeOptions = (data: any) => {
    const locationCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = locationCodeOptions.find((obj: any) => {
        return obj.demand_location_Code === item.demand_location_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        locationCodeOptions.push({
          id: item.id,
          demand_location_Code: item.demand_location_Code,
        });
      }
    });
    return locationCodeOptions;
  };

  const loadLocationDescOptions = (data: any) => {
    const locationDescOptions: any = [];
    data.map((item: any) => {
      const filteredItem = locationDescOptions.find((obj: any) => {
        return (
          obj.demand_Location_Description === item.demand_Location_Description
        );
      });
      if (filteredItem === undefined || filteredItem == null) {
        locationDescOptions.push({
          id: item.id,
          demand_Location_Description: item.demand_Location_Description,
        });
      }
    });
    return locationDescOptions;
  };

  const getfiltersApi = () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");

    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: "tblcog_Demand",
      time_period: "string",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + CGO_DEMAND_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setLocationCodeOptions(loadLocationCodeOptions(response.data));
          setLocationDescOptions(response.data.lineFilter);
          setCascadeOptions(response.data.cascade_NoFilter);
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  const handleRestoreClicked = (e: any) => {
    setSelectLocationCode("");
    setSelectLocationDesc("");
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    callTableGridApi("");
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing2Data", "filter": filterList };
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: "tblcog_Demand",
      time_period: "string",
      filter: filterList,
    };

    const urls = API_BASE_URL + CGO_DEMAND_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable
  );

  const saveEditFilterEnable = useSelector(
    (state: any) => state.InputDataReducers.saveEditFilterEnable
  );

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "demand_location_Code",
      "demand_Location_Description",
      "depot_Lat",
      "depot_Long",
      "demand_Vol",
    ];

    // Collect all unique missing fields across all rows
    const allMissingFields = new Set<string>();
    console.log(getEditedValue, "getEditedValue");
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    console.log(allMissingFields, "allMissingFields");
    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        demand_Location_Description: "",
        demand_Vol: 0,
        demand_location_Code: "",
        depot_Lat: 0.0,
        depot_Long: 0.0,
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    // console.log(getEditedValue, "getEditedValue transformedRows");
    const message = successMessage || "Successfully saved";
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.folder_Id = 0;
        rest.scenario_id = 0;
        return rest;
      }

      return row;
    });

    console.log(transformedRows, "transformedRows");
    const urls = API_BASE_URL + CGO_DEMAND_UPDATE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    putRequest(urls, transformedRows, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          // getfiltersApi();
          setSnackbar({
            children: message,
            severity: "success",
          });
          handleClose();
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited demand table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="demand"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Demand</h3>
          </div>
          <div className="filters">
            <RestoreOutlinedIcon
              className="restoreIcon"
              onClick={(e) => handleRestoreClicked(e)}
            />
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Factory</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectLocationCode}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectLocationCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Location Code</em>
                  </MenuItem>
                  {locationCodeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.demand_location_Code}>
                        {d.demand_location_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Line</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectLocationDesc}
                  placeholder="Select Line"
                  onChange={handleChangeSelectLocationDesc}
                  // renderValue={(selectLine: any) => selectLine}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Location Description</em>
                  </MenuItem>
                  {locationDescOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.demand_Location_Description}>
                        {d.demand_Location_Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}
            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={handleDownload}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <DemandTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default Demand;
